import axios from "axios"
import RestService from "./rest.service";

const API_URL = process.env.REACT_APP_API_URL;

class workloadAndPerformanceService {
  getCategory(data) {
    if (data !== undefined && data !== null && data !== "") {
      return new Promise((fnResolve, fnReject) => {
        RestService.getCategorys(`app/workload_performance/${data}/edit`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      });
    } else {
      return new Promise((fnResolve, fnReject) => {
        RestService.getCategorys("app/workload_performance/add").then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      });
    }
  }

  getForm(serial, data) {
    if (data !== undefined && data !== null && data !== "") {
      return new Promise((fnResolve, fnReject) => {
        RestService.getFormWorkloadAndPerformance(`app/workload_performance/${data}/edit/next/${serial}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      });
    } else {
      return new Promise((fnResolve, fnReject) => {
        RestService.getFormWorkloadAndPerformance(`app/workload_performance/next/${serial}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      });
    }
  }

  getYear() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getYearWorkloadAndPerformance("app/rbpa").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getDetail(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getDetailWorkloadAndPerformance(`app/workload_performance/${data}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getType() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getTypeWorkloadAndPerformance(`app/workload_performance/worktype`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getList(rb_pa_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getListWorkloadAndPerformance(`app/workload_performance?rb_pa_id=${rb_pa_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getSummary(rb_pa_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getSummaryWorkloadAndPerformance(`app/workload_performance/summary?rb_pa_id=${rb_pa_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  uploadFiles(rb_pa_id, file) {
    return new Promise((fnResolve, fnReject) => {
      let data = new FormData();
      for (let index = 0; index <= file.length - 1; index++) {
        data.append("file", file[index]);
      }
      RestService.uploadFilesWorkloadAndPerformance(`app/workload_performance/${rb_pa_id}/files`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getFiles(rb_pa_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getFilesWorkloadAndPerformance(`app/workload_performance/${rb_pa_id}/files`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteFiles(id_files) {
    return new Promise((fnResolve, fnReject) => {
      RestService.deleteFilesWorkloadAndPerformance(`app/workload_performance/file/${id_files}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  openFiles(id_files) {
    return new Promise((fnResolve, fnReject) => {
      RestService.openFilesWorkloadAndPerformance(`app/workload_performance/file/${id_files}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getConfig() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getConfigs(`app/config/upload/portfolio_file`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  addList(data, id) {
    if (id !== undefined && id !== null && id !== "") {
      return new Promise((fnResolve, fnReject) => {
        RestService.put(`app/workload_performance/${id}/edit`, data).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      });
    } else {
      return new Promise((fnResolve, fnReject) => {
        RestService.posts(`app/workload_performance/add`, data).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      });
    }
  }

  DeleteList(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.deleteListsWorkloadAndPerformance(`app/workload_performance/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new workloadAndPerformanceService();
